export default __webpack_public_path__ + "e322d6ec542f78bbcbd24828dbe875f4.jpg";